import {connect} from 'react-redux';
import ThemeColour from './ThemeColour';
import {changeTheme} from '../ducks/theme';
import AnalyticsGateway from '../lib/AnalyticsGateway';
import {updatePreferences} from '../actionCreators/preferences';

const mapStateToProps = (state) => {
  return {
    colour: state.theme.colour || (
      state.coverPageImages.colours[0] !== '#000000' ? state.coverPageImages.colours[0] : '#ffffff'),
    colours: state.coverPageImages.colours,
    propertyId: state.propertyDetail.propertyId,
    reportType: state.reportType.value,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onChange: ({hex}, reportType) => {
    dispatch(changeTheme({colour: hex}));
    dispatch(updatePreferences({'theme.colour': hex}, reportType));
  },
  sendAnalytics: (hex, propertyId, reportType) => {
    AnalyticsGateway.sendEvent({
      eventName: 'Change Colour Theme',
      properties: [
        {label: 'Page', value: 'Customise Report'},
        {label: 'Property ID', value: propertyId},
        {label: 'Colour Hex', value: hex},
        {label: 'Report Type', value: AnalyticsGateway.reportDescription(reportType)},
      ]
    });
  },
});

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  onChange: ({hex}) => {
    const reportType = stateProps.reportType;
    dispatchProps.onChange({hex}, reportType);
    dispatchProps.sendAnalytics(hex, stateProps.propertyId, reportType);
  },
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ThemeColour);